(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["basic-header"]) return;
  try {
    

  window.addEventListener("DOMContentLoaded", function () {

    // Main navigation

    const navButtons = Array.from(document.getElementsByClassName("nav-drawer"))

    const drawer = document.getElementById("drawer-menu")

    const drawerContainer = document.getElementById("drawer-container")

  

    navButtons.forEach(function (btn) {

      btn.addEventListener("click", () => {

        drawer.classList.toggle("open")

      })

    })

  

    drawer.addEventListener("click", () => {

      drawer.classList.toggle("open")

    })

  

    drawerContainer.addEventListener("click", event => {

      event.stopPropagation()

    })

  })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-carousel"] && !Shopify.designMode) return;
  try {
    
(function() {
  var carousels = document.querySelectorAll('.products-carousel');
  
  carousels.forEach(function(container) {
    var carousel = container.querySelector('ul.product-cards');
    if (!carousel) return;
    
    var autoScrollEnabled = carousel.dataset.autoScroll === 'true';
    var pauseDuration = (parseFloat(carousel.dataset.pauseDuration) || 2) * 1000;
    
    var items = carousel.querySelectorAll('.product-card');
    var indicators = container.querySelectorAll('.indicator-dot');
    
    if (items.length <= 1) return;
    
    var currentIndex = 0;
    var autoScrollInterval = null;
    var isPaused = false;
    var resumeTimeout = null;
    
    function updateIndicators(index) {
      for (var i = 0; i < indicators.length; i++) {
        if (i === index) {
          indicators[i].classList.add('active');
        } else {
          indicators[i].classList.remove('active');
        }
      }
    }
    
    function scrollToItem(index) {
      if (index >= items.length) {
        index = 0;
      }
      if (index < 0) {
        index = items.length - 1;
      }
      currentIndex = index;
      
      var item = items[index];
      if (item) {
        var itemRect = item.getBoundingClientRect();
        var carouselRect = carousel.getBoundingClientRect();
        var scrollLeft = carousel.scrollLeft + (item.offsetLeft - carousel.offsetLeft) - (carouselRect.width / 2) + (itemRect.width / 2);
        
        carousel.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
      
      updateIndicators(currentIndex);
    }
    
    function detectCurrentItem() {
      var carouselRect = carousel.getBoundingClientRect();
      var carouselCenter = carouselRect.left + carouselRect.width / 2;
      
      var closestIndex = 0;
      var closestDistance = Infinity;
      
      for (var i = 0; i < items.length; i++) {
        var itemRect = items[i].getBoundingClientRect();
        var itemCenter = itemRect.left + itemRect.width / 2;
        var distance = Math.abs(itemCenter - carouselCenter);
        
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      }
      
      if (closestIndex !== currentIndex) {
        currentIndex = closestIndex;
        updateIndicators(currentIndex);
      }
    }
    
    function autoScroll() {
      if (isPaused) return;
      currentIndex++;
      if (currentIndex >= items.length) {
        currentIndex = 0;
      }
      scrollToItem(currentIndex);
    }
    
    function startAutoScroll() {
      if (autoScrollInterval || !autoScrollEnabled) return;
      autoScrollInterval = setInterval(autoScroll, pauseDuration);
    }
    
    function stopAutoScroll() {
      if (autoScrollInterval) {
        clearInterval(autoScrollInterval);
        autoScrollInterval = null;
      }
    }
    
    function pauseScroll() {
      isPaused = true;
      carousel.classList.add('is-paused');
      stopAutoScroll();
      
      if (resumeTimeout) {
        clearTimeout(resumeTimeout);
      }
    }
    
    function resumeScroll() {
      if (resumeTimeout) {
        clearTimeout(resumeTimeout);
      }
      
      resumeTimeout = setTimeout(function() {
        isPaused = false;
        carousel.classList.remove('is-paused');
        detectCurrentItem();
        startAutoScroll();
      }, 2500);
    }
    
    for (var i = 0; i < indicators.length; i++) {
      (function(index) {
        indicators[index].addEventListener('click', function() {
          pauseScroll();
          scrollToItem(index);
          resumeScroll();
        });
      })(i);
    }
    
    carousel.addEventListener('touchstart', pauseScroll, { passive: true });
    carousel.addEventListener('touchend', resumeScroll, { passive: true });
    
    carousel.addEventListener('mouseenter', pauseScroll);
    carousel.addEventListener('mouseleave', resumeScroll);
    
    var scrollTimeout;
    carousel.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function() {
        detectCurrentItem();
      }, 50);
    }, { passive: true });
    
    var observer = new IntersectionObserver(function(entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          if (!isPaused && autoScrollEnabled) {
            startAutoScroll();
          }
        } else {
          stopAutoScroll();
        }
      }
    }, { threshold: 0.3 });
    
    observer.observe(carousel);
    
    updateIndicators(0);
    
    setTimeout(function() {
      scrollToItem(0);
    }, 100);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
